"use client";

import { FC } from "react";
import DOMPurify from "isomorphic-dompurify";

import { StyledPromptContainer } from "./styles";
import CopyPrompt from "../CopyPrompt";

const sanitizeConfig = {
  ALLOWED_TAGS: [
    "b",
    "strong",
    "i",
    "em",
    "h1",
    "h2",
    "span",
    "p",
    "br",
    "ul",
    "li",
    "ol",
  ],
  ALLOWED_ATTR: ["align", "style", "class", "title"],
};

interface PromptViewerProps {
  rawPrompt: string;
  textPrompt?: string;
}

const PromptViewer: FC<PromptViewerProps> = ({
  rawPrompt,
  textPrompt = "",
}) => {
  const hasPrompt = Boolean(textPrompt || rawPrompt);
  return (
    <StyledPromptContainer>
      <div
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(rawPrompt, sanitizeConfig),
        }}
      />
      {hasPrompt && (
        <CopyPrompt prompt={textPrompt || JSON.stringify(rawPrompt)} />
      )}
    </StyledPromptContainer>
  );
};

export default PromptViewer;
